import axios from 'axios';
import { BASENAME } from '../constants/general';

export function recordEvent(name, data, referrer = null) {
	axios
		.post(BASENAME + '/api/trackEvent', { name: name, data: data, referrer: referrer })
		.then(response => {
			//
		})
		.catch(error => {
			console.error('recordEvent error', error);
		});
}
